export const cityConfig = {
  city: "Kreis Mettmann",
  companyName: "BRIMO Immobilien NRW",
  fullCompanyName: "Bricks and Mortar Immobilien Nordrhein-Westfalen GmbH",
  brand: "BRIMO Immobilien NRW",
  tagline: "Struktur. Vertrauen.",
  address: {
    street: "Wilhelmstraße 3",
    postalCode: "42781",
    city: "Haan",
    state: "Nordrhein-Westfalen",
    country: "Deutschland",
  },
  phone: "+4921293766829",
  phoneDisplay: "+49 2129 3766829",
  whatsapp: "4917672091271",
  email: "info@brimo-immobilien-kreismettmann.de",
  website: "www.brimo-immobilien-kreismettmann.de",
  manager: {
    name: "Janine Muth",
    title: "Standortleitung | Immobilienmaklerin (SGD) | Homestagerin (IHK)",
    photo:
      "https://customer-assets.emergentagent.com/job_0b6954b7-7a0a-4ead-9726-e0037edf015a/artifacts/oyaxow82_IMG_5336%202.jpg",
  },
  districts: [
    {
      name: "Mettmann",
      slug: "mettmann",
      description: "Kreisstadt mit historischem Charme und dem weltbekannten Neandertal",
    },
    {
      name: "Erkrath",
      slug: "erkrath",
      description: "Naturnahes Wohnen zwischen Neandertal und Düsseldorf",
    },
    {
      name: "Haan",
      slug: "haan",
      description: "Die Gartenstadt mit hoher Lebensqualität und zentraler Lage",
    },
    {
      name: "Heiligenhaus",
      slug: "heiligenhaus",
      description: "Grüne Stadt zwischen Velbert und Ratingen mit Familiencharakter",
    },
    {
      name: "Hilden",
      slug: "hilden",
      description: "Lebendige Mittelstadt mit hervorragender Anbindung an Düsseldorf",
    },
    {
      name: "Langenfeld",
      slug: "langenfeld",
      description: "Dynamische Stadt im Süden des Kreises mit starker Infrastruktur",
    },
    {
      name: "Monheim am Rhein",
      slug: "monheim-am-rhein",
      description: "Attraktive Rheinstadt mit innovativer Stadtentwicklung",
    },
    {
      name: "Ratingen",
      slug: "ratingen",
      description: "Größte Stadt im Kreis mit vielfältigem Immobilienangebot",
    },
    {
      name: "Velbert",
      slug: "velbert",
      description: "Die Schlüsselstadt mit solidem Immobilienmarkt und Höhenlage",
    },
    {
      name: "Wülfrath",
      slug: "wuelfrath",
      description: "Idyllische Kleinstadt mit Naturverbundenheit und ruhigen Wohnlagen",
    },
  ],
  images: {
    hero: "https://static.prod-images.emergentagent.com/jobs/0b6954b7-7a0a-4ead-9726-e0037edf015a/images/33fa88b1aa414e44279e2b6c0eaa2fdf89915dc57f23262123602aeb986a38ce.png",
    sellerHero:
      "https://static.prod-images.emergentagent.com/jobs/42ada0df-a68a-464a-87b2-c661f7b68b9a/images/7d6629f9672c53effdb91fd1640180f1cf61334c2fc622cac79c4293b5446b3a.png",
    buyerHero:
      "https://static.prod-images.emergentagent.com/jobs/42ada0df-a68a-464a-87b2-c661f7b68b9a/images/d1ebd045c92e9b24408ad673dfd8f4ed7a5de0f6a93a81e784076fe8660d0de2.png",
    valuationHero:
      "https://static.prod-images.emergentagent.com/jobs/42ada0df-a68a-464a-87b2-c661f7b68b9a/images/702f23570b9f392216c167b01660c60f4631c00079f694a83b5cbc41bea97254.png",
    office:
      "https://static.prod-images.emergentagent.com/jobs/0b6954b7-7a0a-4ead-9726-e0037edf015a/images/33fa88b1aa414e44279e2b6c0eaa2fdf89915dc57f23262123602aeb986a38ce.png",
    shopFront:
      "https://static.prod-images.emergentagent.com/jobs/0b6954b7-7a0a-4ead-9726-e0037edf015a/images/33fa88b1aa414e44279e2b6c0eaa2fdf89915dc57f23262123602aeb986a38ce.png",
    handshake:
      "https://static.prod-images.emergentagent.com/jobs/42ada0df-a68a-464a-87b2-c661f7b68b9a/images/59194b4887f60b6e5a49834a6ad4a6e6d050859812f428ce93854a7a03cc8477.png",
    houseNight:
      "https://static.prod-images.emergentagent.com/jobs/42ada0df-a68a-464a-87b2-c661f7b68b9a/images/592cc536c00726df12eee7bc5b2648e12acbd8a4a09db77cfe2bfac60cc7e55d.png",
  },
  seo: {
    titleSuffix: "| BRIMO Immobilien Kreis Mettmann",
    defaultDescription:
      "BRIMO Immobilien NRW – Ihr professioneller Immobilienmakler im Kreis Mettmann. Fundierte Immobilienbewertung, erfolgreicher Verkauf und kompetente Beratung für Käufer.",
  },
  geo: {
    latitude: 51.2500,
    longitude: 6.9747,
  },
};
